import { render, staticRenderFns } from "./TableSchema.vue?vue&type=template&id=5d4350d8"
import script from "./TableSchema.vue?vue&type=script&lang=ts"
export * from "./TableSchema.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports